<template>
  <div id="app">
    <home v-if="routeName" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Home from '@/components/Home.vue'
export default {
  name: 'App',
  components: { Home },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
    routeName() {
      return this.$route.name
    },
  },
  mounted() {
  },
  methods: {
  },
  async created() {
    const html = document.getElementById('html')
    html.setAttribute('platform', this.platform)
    // web端需要引入广小二
    if (this.platform === 'web') {
      window.GlodonRobotJsSDK.load('https://robot.glodon.com/client/main.html?app=GJW&channel=4-b05a28748b65484eb468305aaec72360&type=plugin')
    }
  },
}
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
  }
</style>
<style lang="less" scoped>
  .content-box{
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    min-height: 100%;
    position: relative;
    z-index: 0;
    &.no-padding{
      padding: 0;
    }
  }
  .content-box-web{
    width: 1310px;
    margin: 0 auto;
    padding: 0;
    min-height: calc(100% - 40px);
    &.web-full-width{
      width: 100%;
      margin: unset;
    }
  }
  .basket{
    position: absolute;
    z-index: 10;
    top: 0;
    right: 24px;
    &.basket-web{
      right: 0;
    }
  }
  .router-view{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
</style>
